module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c(_vm.$layout.component, _vm._b({
    tag: "component"
  }, 'component', _vm.$layout.props, false))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "busy-overlay",
    staticStyle: {
      "display": "none"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/loader.gif")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0aaed326!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 460
// module chunks = 2